<div class="main-content">
  <div class="container-fluid">

    <div class="admin-page-header">
      <div class="header-actions">
        <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#myModal" (click)="clearSelected()">
          <i class="fa fa-plus"></i> Add service
        </button>
      </div>
    </div>

    <loader *ngIf="loading"></loader>

    <div *ngIf="!loading" class="services-table-wrap">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Description</th>
              <th>Epes</th>
              <th>Status</th>
              <th>Effort</th>
              <th>Report</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of deepDives; let i = index;">
              <td>{{ i + 1 }}</td>
              <td>{{ row['name'] }}</td>
              <td>{{ row['description'] }}</td>
              <td>
                <div class="epes-chips">
                  <span *ngFor="let epe of getEpes(row['epes'])" class="epe-chip">
                    {{ getEpeString(epe) }}
                  </span>
                </div>
              </td>
              <td>
                <span class="status-chip" [ngClass]="'status-' + (row['status'] || '').toLowerCase()">
                  {{ row['status'] }}
                </span>
              </td>
              <td>{{ row['effort'] }}</td>
              <td>
                <div class="epes-chips">
                  <ng-container *ngFor="let report of row['report']">
                    <a *ngIf="report.file !== ''" class="row-link" [href]="downloadReport(report, row)">
                      <i class="fa fa-file-text-o"></i> {{ getReportString(report) }}
                    </a>
                    <span *ngIf="report.file === ''" class="epe-chip">{{ getReportString(report) }}</span>
                  </ng-container>
                </div>
              </td>
              <td>
                <div class="action-cell">
                  <button *ngIf="row['status'] !== 'SUBMITTED'" class="btn btn-sm btn-action"
                          data-toggle="modal" data-target="#myModal" (click)="openEditModal(row)">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button *ngIf="row['status'] === 'SUBMITTED'" class="btn btn-sm btn-action"
                          data-toggle="modal" data-target="#myModal2" (click)="openEditModal(row, true)">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-danger" (click)="alertConfirmation(row)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>

<div class="modal fade" id="myModal" tabindex="-1" role="dialog" data-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i style="color: #d9534f;" class="fa fa-times"></i>
                </button>
                <h4 class="modal-title">{{isEdit ? 'Edit' : 'Add'}} Service</h4>
            </div>
            <div class="modal-body">
                <form (ngSubmit)="onSubmit('SUBMITTED')" #serviceForm="ngForm">
                    <div class="form-group" style="margin: 0">
                        <label for="epe">Search Epe:</label>
                        <input id="epe" #epeSearchInput placeholder="Search Epe By Name" class="form-control" type="text" autocomplete="off" (click)="addListener()">
                    </div>

                    <!--  DropDown Starts  -->
                    <div *ngIf="showSearches" class="card">
                        <div class="search">
                            <div *ngFor="let epe of searchedEpes;" (click)="setEpe(epe)" class="search-result">
                                {{epe.name + ' ' + epe.surname + ' - ' + epe.email}}
                            </div>
                        </div>
                        <p class="search" *ngIf="searchedEpes && searchedEpes.length <= 0">No Epe found</p>
                    </div>

                    <!-- Epe selected list  -->
                    <div class="form-group" style="margin-top: 20px;">
                        <label for="epe">Selected Epe:</label>
                        <div class="selected-epe">
                            <div *ngFor="let epe of selectedEpes" class="selected-epe-item">
                                <span>{{epe.name + ' ' + epe.surname + ' - ' + epe.email}}</span>
                                <i (click)="removeEpe(epe)" class="fa fa-times"></i>
                            </div>
                            <div *ngIf="selectedEpes.length <= 0" class="selected-epe-item">
                                <span>No Epe selected</span>
                            </div>
                        </div>
                    </div>

                    <!-- Input fields for Service Name, Description, and Effort -->
                    <div class="form-group">
                        <label for="serviceName">Service Name</label>
                        <input type="text" class="form-control" id="serviceName" [(ngModel)]="serviceName" name="serviceName" required>
                    </div>

                    <div class="form-group">
                        <label for="description">Description</label>
                        <textarea class="form-control" id="description" [(ngModel)]="description" name="description" required></textarea>
                    </div>

                    <div class="form-group">
                        <label for="effort">Effort</label>
                        <input type="text" class="form-control" id="effort" [(ngModel)]="effort" name="effort" required>
                    </div>


                </form>
            </div>
            <div class="modal-footer" style="display: flex; justify-content: end;">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-warning" data-dismiss="modal" (click)="onSubmit('DRAFT')">Save as Draft</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal"
                        [disabled]="!serviceForm.form.valid"
                        (click)="onSubmit('SUBMITTED')">
                  <i class="fa fa-paper-plane"></i> Save & Submit
                </button>
            </div>
        </div>

    </div>
</div>

<div class="modal fade" id="myModal2" tabindex="-1" role="dialog" data-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i style="color: #d9534f;" class="fa fa-times"></i>
                </button>
                <h4 class="modal-title">Edit Effort Service</h4>
            </div>
            <div class="modal-body">
                <form (ngSubmit)="onSubmit('SUBMITTED')" #serviceForm="ngForm">
                    <div>
                        <h5>
                            Epes:
                        </h5>
                        <div class="selected-epe">
                            <div *ngFor="let epe of selectedEpes" class="selected-epe-item">
                                <span>{{epe.name + ' ' + epe.surname + ' - ' + epe.email}}</span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h5>
                            Service Name:
                        </h5>
                        <p>
                            {{ serviceName }}
                        </p>
                    </div>
                    <div>
                        <h5>
                            Description:
                        </h5>
                        <p>
                            {{ description }}
                        </p>
                    </div>

                    <div class="form-group">
                        <label for="effort">Effort</label>
                        <input type="text" class="form-control" id="effort2" [(ngModel)]="effort" name="effort" required>
                    </div>

                </form>
            </div>
            <div class="modal-footer" style="display: flex; justify-content: end;">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal"
                        [disabled]="!serviceForm.form.valid"
                        (click)="onSubmit('SUBMITTED')">
                  <i class="fa fa-paper-plane"></i> Submit
                </button>
            </div>
        </div>

    </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert" ></simple-alert>
